export default "__VITE_ASSET__2b0648ca__"